import { render, staticRenderFns } from "./editProviderFeaturedGame.vue?vue&type=template&id=1ba86620&lang=pug"
import script from "./editProviderFeaturedGame.vue?vue&type=script&lang=js"
export * from "./editProviderFeaturedGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports